/**
 * FiltersPanel Component
 *
 * Collapsible panel wrapper for filter components
 */

import { memo } from 'react';
import { Stack } from '@mantine/core';
import type { FiltersPanelProps } from '../SearchAndFilters.types';
import { useSearchAndFiltersContext } from '../hooks/useSearchAndFiltersContext';
import styles from '../SearchAndFilters.module.css';

export const FiltersPanel = memo(function FiltersPanel({
  expanded,
  children
}: FiltersPanelProps) {
  const { variant } = useSearchAndFiltersContext();
  const baseClassName = variant === 'compact'
    ? `${styles.filtersPanel} ${styles.compact}`
    : styles.filtersPanel;
  const className = `${baseClassName} ${expanded ? styles.expanded : ''}`;

  return (
    <div className={className}>
      <div className={styles.filtersPanelInner}>
        <Stack gap="md">
          {children}
        </Stack>
      </div>
    </div>
  );
});
